import { ResetPasswordViewRedesigned } from "./ResetPasswordViewRedesigned";

export interface ResetPasswordViewProps {
  step: "confirm" | "success";
  email: string;
  newPassword: string;
  confirmPassword: string;
  isSubmitting: boolean;
  error: string | undefined;
  hasActiveSession: boolean;
  onNewPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  onSubmit: (formEvent: React.FormEvent) => void;
  onGoToLogin: () => void;
}

export function ResetPasswordView(props: ResetPasswordViewProps) {
  return <ResetPasswordViewRedesigned {...props} />;
}
